import { createContext } from "preact";
import { HistoryServiceInterface } from '@authentic/loyalty-pwa/interfaces/history.service.interface';

export const HistoryServiceContext = createContext<HistoryServiceInterface | null>(null)
